const my = window["my"] as any;

/**
 * 千牛全局api
 */
export default my;
